import React from "react"
import types from "prop-types"
import { useFormSubmissionFormContext } from "contexts/FormSubmissionFormContext"
import { numberDate } from "utils/dateHelpers"
import Modal, { ModalHeader } from "shared/Modal"
import EDIT_SUBMISSION_MODAL_STYLE from "./editSubmissionModalStyle"
import EditSubmissionOptionCard from "./EditSubmissionOptionCard"

// A user thinks of the version that was submitted as the submission's current
// version, and of the form's current version as a new version.  The cards are
// labeled that way, while the options remain named for the versions themselves.
const EditSubmissionVersionModal = ({
  close, isOpen, onEditCurrentFormVersion, onEditSubmittedFormVersion,
}) => {
  const { currentFormVersion } = useFormSubmissionFormContext()
  const { createdAt } = currentFormVersion

  // The current version of the form is loaded before this modal is opened.
  if (!createdAt) return null

  return (
    <Modal isOpen={isOpen} style={EDIT_SUBMISSION_MODAL_STYLE}>
      <ModalHeader
        closeModal={close}
        heading="Change Answers"
      />
      <p className="mb-8 text-sm text-center text-gray">
        There is a newer version of this form.
        <br />
        Which version would you like to use for the edit?
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <EditSubmissionOptionCard
          description="Use the same version this submission is on."
          onClick={onEditSubmittedFormVersion}
          title="Current Version"
        />
        <EditSubmissionOptionCard
          description={`Use the version released on ${numberDate(createdAt)}.`}
          onClick={onEditCurrentFormVersion}
          title="New Version"
        />
      </div>
    </Modal>
  )
}

EditSubmissionVersionModal.propTypes = {
  close: types.func.isRequired,
  isOpen: types.bool.isRequired,
  onEditCurrentFormVersion: types.func.isRequired,
  onEditSubmittedFormVersion: types.func.isRequired,
}

export default EditSubmissionVersionModal
